import { createFileRoute } from '@tanstack/react-router';

import { OwnerPlanPage } from '@/features/billing/plan-page';

export const Route = createFileRoute('/_app/projects/$projectId/owner-plan')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  return <OwnerPlanPage projectId={projectId} />;
}
